<template lang="pug">
.guide
  .guide-kv
    .guide-kv-image
      img.guide-kv-img(src="/static/images/manual/guide_kv.webp")
    .guide-kv-underWrapper
      .guide-kv-parallelBox
        .guide-kv-parallelBox-sidePanel
        .guide-kv-parallelBox-articleMainContents
          h2.guide-kv-parallelBox-articleMainContents-text 特定企業の分析
  .guide-breadcrumb(v-for="page in pages")
    .guide-breadcrumb-child
      a.guide-breadcrumb-child-link(:href="page.indexLink") 市況分析
      p.guide-breadcrumb-child-slach &nbsp;/&nbsp;
      p.guide-breadcrumb-child-current ターゲットを明確にする
  .guide-parallelBox
    .guide-sidePanel
      dl.guide-sidePanel-inner(v-for="list in sideContents")
        dt.guide-sidePanel-section
          .guide-sidePanel-section-title {{ list.sidePanelSection }}
          dd.guide-sidePanel-article(v-for="title in list.articleList")
            a.guide-sidePanel-article-link(:href="title.articlelink" :class="{ '-isCurrent': title.isCurrent}" v-if="title.isTwoLine")
              span.guide-sidePanel-article-link-oneLine {{ title.articleTextOneLine }}
              br
              span.guide-sidePanel-article-link-twoLine {{ title.articleTextTwoLine }}
            a.guide-sidePanel-article-link(:href="title.articlelink" :class="{ '-isCurrent': title.isCurrent}" v-else) {{ title.articleText }}

    .guide-articleMainContents
      .guide-articleMainContents-inner
        .guide-articleMainContents-headLineWrap
            h3.guide-articleMainContents-headLineWrap-headLine ターゲットを明確にする
        .guide-articleMainContents-contents
          p.guide-articleMainContents-textDetail 集計する数値をより具体的にするために、事前に目的とターゲット領域を明確にしておく必要があります。例えば、自社商圏の中で、競合他社が出稿している求人数の推移を見て、競合が手薄な職種を把握したいという場合には、「集計縦軸：職種」、「エリアの項目(勤務地など)：自社商圏のエリア」を設定する必要があります。
          .guide-articleMainContents-image(v-if="identifier () === 'kobot'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/kobot/guide_3b_01.webp")
          .guide-articleMainContents-image(v-else-if="identifier () === 'mynavi'")
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/mynavi/guide_3b_01.webp")
          .guide-articleMainContents-image(v-else)
            img.guide-articleMainContents-image-img(src="/static/images/manual/market-analysis/guide_3b_01.webp")

      .guide-articleMainContents-movePage(v-for="page in pages")
        a.guide-articleMainContents-movePage-container.-pageBack(:href="page.backLink")
          .guide-articleMainContents-movePage-container-outer
            .guide-articleMainContents-movePage-container-inner
              .guide-articleMainContents-movePage-container-textArea
                p.guide-articleMainContents-movePage-container-title {{ page.backPageTitle }}
                p.guide-articleMainContents-movePage-container-text {{ page.backPageText }}
              .guide-articleMainContents-movePage-container-image
                img.guide-articleMainContents-movePage-container-img(src="/static/images/manual/guide_icon_arrow.svg")
        a.guide-articleMainContents-movePage-pageIndex(:href="page.indexLink")
          .guide-articleMainContents-movePage-pageIndex-outer
            .guide-articleMainContents-movePage-pageIndex-inner
              .guide-articleMainContents-movePage-pageIndex-image
                img.guide-articleMainContents-movePage-pageIndex-img(src="/static/images/manual/guide_icon_index.svg")
              p.guide-articleMainContents-movePage-pageIndex-title 市況分析一覧
        a.guide-articleMainContents-movePage-container.-pageNext(:href="page.nextLink")
          .guide-articleMainContents-movePage-container-outer
            .guide-articleMainContents-movePage-container-inner
              .guide-articleMainContents-movePage-container-textArea
                p.guide-articleMainContents-movePage-container-title {{ page.nextPageTitle }}
                p.guide-articleMainContents-movePage-container-text {{ page.nextPageText }}
              .guide-articleMainContents-movePage-container-image
                img.guide-articleMainContents-movePage-container-img(src="/static/images/manual/guide_icon_arrow.svg")
</template>

<script>
export default {
  data () {
    return {
      job_notification_settings: '',
      headLineTitle: '',
      textOnly: '',
      image: '',
      titleTextTitle: '',
      titleTextText: '',
      isCurrent: '',
      sideContents: [
        {
          sidePanelSection: '1. 基本的な操作方法',
          articleList: [
            {
              articlelink: '/guide/market_analysis/1-a',
              articleText: 'a. 市況分析機能の概要',
            },
            {
              articlelink: '/guide/market_analysis/1-b',
              articleText: 'b. 集計の目的と集計対象を決める',
            },
            {
              articlelink: '/guide/market_analysis/1-c',
              articleText: 'c. 集計に使う求人を指定する',
            },
            {
              articlelink: '/guide/market_analysis/1-d',
              articleText: 'd. 集計した条件を保存する',
            },
            {
              articlelink: '/guide/market_analysis/1-e',
              articleText: 'e. 集計した値をDLする',
            },
          ],
        },
        {
          sidePanelSection: '2. 商圏の求人動向分析',
          articleList: [
            {
              articlelink: '/guide/market_analysis/2-a',
              articleText: 'a. 活用のイメージ',
            },
            {
              articlelink: '/guide/market_analysis/2-b',
              articleText: 'b. ターゲット領域を決める',
            },
            {
              articlelink: '/guide/market_analysis/2-c',
              articleText: 'c. 集計から省きたい企業を登録する',
            },
            {
              isTwoLine: true,
              articlelink: '/guide/market_analysis/2-d',
              articleTextOneLine: 'd. 集計に使う条件を指定して',
              articleTextTwoLine: '条件を保存する',
            },
          ],
        },
        {
          sidePanelSection: '3. 特定企業の分析',
          articleList: [
            {
              articlelink: '/guide/market_analysis/3-a',
              articleText: 'a. 活用のイメージ',
            },
            {
              isCurrent: true,
              articlelink: '/guide/market_analysis/3-b',
              articleText: 'b. ターゲットを明確にする',
            },
            {
              articlelink: '/guide/market_analysis/3-c',
              articleText: 'c. 集計したい企業を登録する',
            },
            {
              articlelink: '/guide/market_analysis/3-d',
              articleText: 'd. 集計から省きたい企業を登録する',
            },
            {
              isTwoLine: true,
              articlelink: '/guide/market_analysis/3-e',
              articleTextOneLine: 'e. 集計に使う条件を指定して',
              articleTextTwoLine: '条件を保存する',
            },
          ],
        },
      ],

      pages: [
        {
          backLink: '/guide/market_analysis/3-a',
          backPageTitle: '3. 特定企業の分析',
          backPageText: 'a. 活用のイメージ',
          indexLink: '/guide/market_analysis',
          nextLink: '/guide/market_analysis/3-c',
          nextPageTitle: '3. 特定企業の分析',
          nextPageText: 'c. 集計したい企業を登録する',
        },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/guide/market-analysis/overview/3-b.vue